module.exports = __webpack_public_path__ + "img/FooterItem.1d54cf68.svg";